import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	toggleFilterSections,
	getFilterSubjects,
	setFilterSubject,
	resetFilterSelectedTopics,
} from '../../../../redux/actions';
import { Dropdown, Icon, Checkbox, Loader } from '../../../../components';
import colors from '../../../../utils/colors';

function Subjects() {
	const state = useSelector((state) => state);
	const dispatch = useDispatch();
	const [subjectFilter, setSubjectFilter] = useState(new RegExp('', 'gi'));

	const selected = state.filter.selected;

	const handleFilterList = (value, callback) => {
		if (value.match(/[a-z0-9]/gi) !== null) {
			callback(new RegExp(value.match(/[a-z0-9]/gi).join(''), 'gi'));
		} else {
			callback(new RegExp(''));
		}
	};

	useEffect(() => {
		if (selected.level) {
			dispatch(getFilterSubjects(selected.level, selected.classes));
		}
		// dispatch(resetFilterSelectedSubjects());
	}, [selected.level, selected.classes, dispatch]);

	return (
		<Dropdown
			className="subject-dropdown"
			title="Przedmiot"
			name="subjects"
			isOpen={state.filter.activeSections.indexOf('subjects') !== -1}
			onClick={() => {
				setSubjectFilter(new RegExp(''));
				dispatch(toggleFilterSections('subjects'));
			}}
			selected={
				state.filter.subjects &&
				selected.subjects.length > 0 && (
					<ul>
						{selected.subjects.map((subjectID) => (
							<li key={`subject-${subjectID}`}>
								{state.filter.subjects[selected.level] &&
									state.filter.subjects[selected.level].find((subject) => subject.id === subjectID)
										.przedmiot}
							</li>
						))}
					</ul>
				)
			}
		>
			<div className="dropdown-input">
				<input
					placeholder="Wyszukaj przedmiot"
					onChange={(e) => handleFilterList(e.target.value, setSubjectFilter)}
				/>
				<Icon name="search" color={colors.greyDark} width="13" height="13" />
			</div>
			<ul className="dropdown-list" onClick={() => {}}>
				{state.filter.loadingSections.includes('subjects') ? (
					<li className="loader-container">
						<Loader type="ellipsis" />
					</li>
				) : selected.level && state.filter.subjects && state.filter.subjects[selected.level] ? (
					state.filter.subjects[selected.level]
						.filter((subject) => subject.przedmiot.match(subjectFilter))
						.map((subject) => (
							<li className="dropdown-list-item" key={subject.id}>
								<Checkbox
									id={subject.id}
									label={subject.przedmiot}
									checked={selected.subjects.includes(subject.id)}
									onChange={() => {
										dispatch(resetFilterSelectedTopics());
										dispatch(setFilterSubject(subject.id));
										dispatch(toggleFilterSections('subjects'));
										if (!state.filter.activeSections.includes('topics')) {
											dispatch(toggleFilterSections('topics'));
										}
									}}
								/>
							</li>
						))
				) : (
					<li className="dropdown-list-item">Brak</li>
				)}
			</ul>
		</Dropdown>
	);
}

export default Subjects;
